import ke, { useState as U, useRef as Fe, useEffect as z, useCallback as fr, forwardRef as dr, useImperativeHandle as vr } from "react";
var oe = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ae;
function pr() {
  if (Ae)
    return W;
  Ae = 1;
  var f = ke, d = Symbol.for("react.element"), C = Symbol.for("react.fragment"), R = Object.prototype.hasOwnProperty, h = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, E = { key: !0, ref: !0, __self: !0, __source: !0 };
  function w(s, c, p) {
    var i, a = {}, y = null, S = null;
    p !== void 0 && (y = "" + p), c.key !== void 0 && (y = "" + c.key), c.ref !== void 0 && (S = c.ref);
    for (i in c)
      R.call(c, i) && !E.hasOwnProperty(i) && (a[i] = c[i]);
    if (s && s.defaultProps)
      for (i in c = s.defaultProps, c)
        a[i] === void 0 && (a[i] = c[i]);
    return { $$typeof: d, type: s, key: y, ref: S, props: a, _owner: h.current };
  }
  return W.Fragment = C, W.jsx = w, W.jsxs = w, W;
}
var B = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var De;
function mr() {
  return De || (De = 1, process.env.NODE_ENV !== "production" && function() {
    var f = ke, d = Symbol.for("react.element"), C = Symbol.for("react.portal"), R = Symbol.for("react.fragment"), h = Symbol.for("react.strict_mode"), E = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), s = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), i = Symbol.for("react.suspense_list"), a = Symbol.for("react.memo"), y = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), j = Symbol.iterator, _ = "@@iterator";
    function k(e) {
      if (e === null || typeof e != "object")
        return null;
      var r = j && e[j] || e[_];
      return typeof r == "function" ? r : null;
    }
    var O = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function v(e) {
      {
        for (var r = arguments.length, t = new Array(r > 1 ? r - 1 : 0), n = 1; n < r; n++)
          t[n - 1] = arguments[n];
        b("error", e, t);
      }
    }
    function b(e, r, t) {
      {
        var n = O.ReactDebugCurrentFrame, l = n.getStackAddendum();
        l !== "" && (r += "%s", t = t.concat([l]));
        var m = t.map(function(u) {
          return String(u);
        });
        m.unshift("Warning: " + r), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var g = !1, D = !1, N = !1, $e = !1, Ye = !1, se;
    se = Symbol.for("react.module.reference");
    function Me(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === R || e === E || Ye || e === h || e === p || e === i || $e || e === S || g || D || N || typeof e == "object" && e !== null && (e.$$typeof === y || e.$$typeof === a || e.$$typeof === w || e.$$typeof === s || e.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === se || e.getModuleId !== void 0));
    }
    function Ne(e, r, t) {
      var n = e.displayName;
      if (n)
        return n;
      var l = r.displayName || r.name || "";
      return l !== "" ? t + "(" + l + ")" : t;
    }
    function ue(e) {
      return e.displayName || "Context";
    }
    function F(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && v("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case R:
          return "Fragment";
        case C:
          return "Portal";
        case E:
          return "Profiler";
        case h:
          return "StrictMode";
        case p:
          return "Suspense";
        case i:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case s:
            var r = e;
            return ue(r) + ".Consumer";
          case w:
            var t = e;
            return ue(t._context) + ".Provider";
          case c:
            return Ne(e, e.render, "ForwardRef");
          case a:
            var n = e.displayName || null;
            return n !== null ? n : F(e.type) || "Memo";
          case y: {
            var l = e, m = l._payload, u = l._init;
            try {
              return F(u(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var $ = Object.assign, V = 0, ce, le, fe, de, ve, pe, me;
    function he() {
    }
    he.__reactDisabledLog = !0;
    function Ve() {
      {
        if (V === 0) {
          ce = console.log, le = console.info, fe = console.warn, de = console.error, ve = console.group, pe = console.groupCollapsed, me = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: he,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        V++;
      }
    }
    function Le() {
      {
        if (V--, V === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: $({}, e, {
              value: ce
            }),
            info: $({}, e, {
              value: le
            }),
            warn: $({}, e, {
              value: fe
            }),
            error: $({}, e, {
              value: de
            }),
            group: $({}, e, {
              value: ve
            }),
            groupCollapsed: $({}, e, {
              value: pe
            }),
            groupEnd: $({}, e, {
              value: me
            })
          });
        }
        V < 0 && v("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var X = O.ReactCurrentDispatcher, Z;
    function q(e, r, t) {
      {
        if (Z === void 0)
          try {
            throw Error();
          } catch (l) {
            var n = l.stack.trim().match(/\n( *(at )?)/);
            Z = n && n[1] || "";
          }
        return `
` + Z + e;
      }
    }
    var Q = !1, J;
    {
      var We = typeof WeakMap == "function" ? WeakMap : Map;
      J = new We();
    }
    function ge(e, r) {
      if (!e || Q)
        return "";
      {
        var t = J.get(e);
        if (t !== void 0)
          return t;
      }
      var n;
      Q = !0;
      var l = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = X.current, X.current = null, Ve();
      try {
        if (r) {
          var u = function() {
            throw Error();
          };
          if (Object.defineProperty(u.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(u, []);
            } catch (I) {
              n = I;
            }
            Reflect.construct(e, [], u);
          } else {
            try {
              u.call();
            } catch (I) {
              n = I;
            }
            e.call(u.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (I) {
            n = I;
          }
          e();
        }
      } catch (I) {
        if (I && n && typeof I.stack == "string") {
          for (var o = I.stack.split(`
`), P = n.stack.split(`
`), x = o.length - 1, T = P.length - 1; x >= 1 && T >= 0 && o[x] !== P[T]; )
            T--;
          for (; x >= 1 && T >= 0; x--, T--)
            if (o[x] !== P[T]) {
              if (x !== 1 || T !== 1)
                do
                  if (x--, T--, T < 0 || o[x] !== P[T]) {
                    var A = `
` + o[x].replace(" at new ", " at ");
                    return e.displayName && A.includes("<anonymous>") && (A = A.replace("<anonymous>", e.displayName)), typeof e == "function" && J.set(e, A), A;
                  }
                while (x >= 1 && T >= 0);
              break;
            }
        }
      } finally {
        Q = !1, X.current = m, Le(), Error.prepareStackTrace = l;
      }
      var M = e ? e.displayName || e.name : "", je = M ? q(M) : "";
      return typeof e == "function" && J.set(e, je), je;
    }
    function Be(e, r, t) {
      return ge(e, !1);
    }
    function Ue(e) {
      var r = e.prototype;
      return !!(r && r.isReactComponent);
    }
    function G(e, r, t) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ge(e, Ue(e));
      if (typeof e == "string")
        return q(e);
      switch (e) {
        case p:
          return q("Suspense");
        case i:
          return q("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case c:
            return Be(e.render);
          case a:
            return G(e.type, r, t);
          case y: {
            var n = e, l = n._payload, m = n._init;
            try {
              return G(m(l), r, t);
            } catch {
            }
          }
        }
      return "";
    }
    var H = Object.prototype.hasOwnProperty, ye = {}, Re = O.ReactDebugCurrentFrame;
    function K(e) {
      if (e) {
        var r = e._owner, t = G(e.type, e._source, r ? r.type : null);
        Re.setExtraStackFrame(t);
      } else
        Re.setExtraStackFrame(null);
    }
    function ze(e, r, t, n, l) {
      {
        var m = Function.call.bind(H);
        for (var u in e)
          if (m(e, u)) {
            var o = void 0;
            try {
              if (typeof e[u] != "function") {
                var P = Error((n || "React class") + ": " + t + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              o = e[u](r, u, n, t, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (x) {
              o = x;
            }
            o && !(o instanceof Error) && (K(l), v("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", n || "React class", t, u, typeof o), K(null)), o instanceof Error && !(o.message in ye) && (ye[o.message] = !0, K(l), v("Failed %s type: %s", t, o.message), K(null));
          }
      }
    }
    var qe = Array.isArray;
    function ee(e) {
      return qe(e);
    }
    function Je(e) {
      {
        var r = typeof Symbol == "function" && Symbol.toStringTag, t = r && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return t;
      }
    }
    function Ge(e) {
      try {
        return Ee(e), !1;
      } catch {
        return !0;
      }
    }
    function Ee(e) {
      return "" + e;
    }
    function _e(e) {
      if (Ge(e))
        return v("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Je(e)), Ee(e);
    }
    var L = O.ReactCurrentOwner, He = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, be, xe, re;
    re = {};
    function Ke(e) {
      if (H.call(e, "ref")) {
        var r = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function Xe(e) {
      if (H.call(e, "key")) {
        var r = Object.getOwnPropertyDescriptor(e, "key").get;
        if (r && r.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Ze(e, r) {
      if (typeof e.ref == "string" && L.current && r && L.current.stateNode !== r) {
        var t = F(L.current.type);
        re[t] || (v('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(L.current.type), e.ref), re[t] = !0);
      }
    }
    function Qe(e, r) {
      {
        var t = function() {
          be || (be = !0, v("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: t,
          configurable: !0
        });
      }
    }
    function er(e, r) {
      {
        var t = function() {
          xe || (xe = !0, v("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", r));
        };
        t.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: t,
          configurable: !0
        });
      }
    }
    var rr = function(e, r, t, n, l, m, u) {
      var o = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: d,
        // Built-in properties that belong on the element
        type: e,
        key: r,
        ref: t,
        props: u,
        // Record the component responsible for creating this element.
        _owner: m
      };
      return o._store = {}, Object.defineProperty(o._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(o, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: n
      }), Object.defineProperty(o, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: l
      }), Object.freeze && (Object.freeze(o.props), Object.freeze(o)), o;
    };
    function tr(e, r, t, n, l) {
      {
        var m, u = {}, o = null, P = null;
        t !== void 0 && (_e(t), o = "" + t), Xe(r) && (_e(r.key), o = "" + r.key), Ke(r) && (P = r.ref, Ze(r, l));
        for (m in r)
          H.call(r, m) && !He.hasOwnProperty(m) && (u[m] = r[m]);
        if (e && e.defaultProps) {
          var x = e.defaultProps;
          for (m in x)
            u[m] === void 0 && (u[m] = x[m]);
        }
        if (o || P) {
          var T = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          o && Qe(u, T), P && er(u, T);
        }
        return rr(e, o, P, l, n, L.current, u);
      }
    }
    var te = O.ReactCurrentOwner, we = O.ReactDebugCurrentFrame;
    function Y(e) {
      if (e) {
        var r = e._owner, t = G(e.type, e._source, r ? r.type : null);
        we.setExtraStackFrame(t);
      } else
        we.setExtraStackFrame(null);
    }
    var ne;
    ne = !1;
    function ae(e) {
      return typeof e == "object" && e !== null && e.$$typeof === d;
    }
    function Te() {
      {
        if (te.current) {
          var e = F(te.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function nr(e) {
      {
        if (e !== void 0) {
          var r = e.fileName.replace(/^.*[\\\/]/, ""), t = e.lineNumber;
          return `

Check your code at ` + r + ":" + t + ".";
        }
        return "";
      }
    }
    var Se = {};
    function ar(e) {
      {
        var r = Te();
        if (!r) {
          var t = typeof e == "string" ? e : e.displayName || e.name;
          t && (r = `

Check the top-level render call using <` + t + ">.");
        }
        return r;
      }
    }
    function Ce(e, r) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var t = ar(r);
        if (Se[t])
          return;
        Se[t] = !0;
        var n = "";
        e && e._owner && e._owner !== te.current && (n = " It was passed a child from " + F(e._owner.type) + "."), Y(e), v('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', t, n), Y(null);
      }
    }
    function Oe(e, r) {
      {
        if (typeof e != "object")
          return;
        if (ee(e))
          for (var t = 0; t < e.length; t++) {
            var n = e[t];
            ae(n) && Ce(n, r);
          }
        else if (ae(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var l = k(e);
          if (typeof l == "function" && l !== e.entries)
            for (var m = l.call(e), u; !(u = m.next()).done; )
              ae(u.value) && Ce(u.value, r);
        }
      }
    }
    function ir(e) {
      {
        var r = e.type;
        if (r == null || typeof r == "string")
          return;
        var t;
        if (typeof r == "function")
          t = r.propTypes;
        else if (typeof r == "object" && (r.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        r.$$typeof === a))
          t = r.propTypes;
        else
          return;
        if (t) {
          var n = F(r);
          ze(t, e.props, "prop", n, e);
        } else if (r.PropTypes !== void 0 && !ne) {
          ne = !0;
          var l = F(r);
          v("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", l || "Unknown");
        }
        typeof r.getDefaultProps == "function" && !r.getDefaultProps.isReactClassApproved && v("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function or(e) {
      {
        for (var r = Object.keys(e.props), t = 0; t < r.length; t++) {
          var n = r[t];
          if (n !== "children" && n !== "key") {
            Y(e), v("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", n), Y(null);
            break;
          }
        }
        e.ref !== null && (Y(e), v("Invalid attribute `ref` supplied to `React.Fragment`."), Y(null));
      }
    }
    function Pe(e, r, t, n, l, m) {
      {
        var u = Me(e);
        if (!u) {
          var o = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (o += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = nr(l);
          P ? o += P : o += Te();
          var x;
          e === null ? x = "null" : ee(e) ? x = "array" : e !== void 0 && e.$$typeof === d ? (x = "<" + (F(e.type) || "Unknown") + " />", o = " Did you accidentally export a JSX literal instead of a component?") : x = typeof e, v("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", x, o);
        }
        var T = tr(e, r, t, l, m);
        if (T == null)
          return T;
        if (u) {
          var A = r.children;
          if (A !== void 0)
            if (n)
              if (ee(A)) {
                for (var M = 0; M < A.length; M++)
                  Oe(A[M], e);
                Object.freeze && Object.freeze(A);
              } else
                v("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Oe(A, e);
        }
        return e === R ? or(T) : ir(T), T;
      }
    }
    function sr(e, r, t) {
      return Pe(e, r, t, !0);
    }
    function ur(e, r, t) {
      return Pe(e, r, t, !1);
    }
    var cr = ur, lr = sr;
    B.Fragment = R, B.jsx = cr, B.jsxs = lr;
  }()), B;
}
process.env.NODE_ENV === "production" ? oe.exports = pr() : oe.exports = mr();
var Ie = oe.exports;
const hr = (f, d, C, R) => {
  let h = d / (C + R), E = Math.floor(f.length / h);
  h > f.length && (h = f.length, E = 1);
  const w = [];
  for (let s = 0; s < h; s++) {
    let c = 0;
    for (let p = 0; p < E && s * E + p < f.length; p++)
      c += f[s * E + p];
    w.push(c / E);
  }
  return w;
}, gr = (f, d, C, R, h, E) => {
  const w = d.height / 2, s = d.getContext("2d");
  s && (s.clearRect(0, 0, d.width, d.height), h !== "transparent" && (s.fillStyle = h, s.fillRect(0, 0, d.width, d.height)), f.forEach((c, p) => {
    s.fillStyle = E;
    const i = p * (C + R), a = w - c / 2, y = C, S = c || 1;
    s.beginPath(), s.roundRect ? (s.roundRect(i, a, y, S, 50), s.fill()) : s.fillRect(i, a, y, S);
  }));
}, _r = ({
  mediaRecorder: f,
  width: d = "100%",
  height: C = "100%",
  barWidth: R = 2,
  gap: h = 1,
  backgroundColor: E = "transparent",
  barColor: w = "rgb(160, 198, 255)",
  fftSize: s = 1024,
  maxDecibels: c = -10,
  minDecibels: p = -90,
  smoothingTimeConstant: i = 0.4
}) => {
  const [a, y] = U(), [S, j] = U(), [_, k] = U(), O = Fe(null);
  z(() => {
    if (!f.stream)
      return;
    const g = new AudioContext(), D = g.createAnalyser();
    k(D), D.fftSize = s, D.minDecibels = p, D.maxDecibels = c, D.smoothingTimeConstant = i;
    const N = g.createMediaStreamSource(f.stream);
    return N.connect(D), y(g), j(N), () => {
      N.disconnect(), D.disconnect(), g.state !== "closed" && g.close();
    };
  }, [f.stream]), z(() => {
    _ && f.state === "recording" && v();
  }, [_, f.state]);
  const v = fr(() => {
    if (!_ || !a)
      return;
    const g = new Uint8Array(_ == null ? void 0 : _.frequencyBinCount);
    f.state === "recording" ? (_ == null || _.getByteFrequencyData(g), b(g), requestAnimationFrame(v)) : f.state === "paused" ? b(g) : f.state === "inactive" && a.state !== "closed" && a.close();
  }, [_, a == null ? void 0 : a.state]);
  z(() => () => {
    a && a.state !== "closed" && a.close(), S == null || S.disconnect(), _ == null || _.disconnect();
  }, []);
  const b = (g) => {
    if (!O.current)
      return;
    const D = hr(
      g,
      O.current.width,
      R,
      h
    );
    gr(
      D,
      O.current,
      R,
      h,
      E,
      w
    );
  };
  return /* @__PURE__ */ Ie.jsx(
    "canvas",
    {
      ref: O,
      width: d,
      height: C,
      style: {
        aspectRatio: "unset"
      }
    }
  );
}, yr = (f, d, C, R, h) => {
  const E = f.getChannelData(0), w = C / (R + h), s = Math.floor(E.length / w), c = d / 2;
  let p = [], i = 0;
  for (let a = 0; a < w; a++) {
    const y = [];
    let S = 0;
    const j = [];
    let _ = 0;
    for (let b = 0; b < s && a * s + b < f.length; b++) {
      const g = E[a * s + b];
      g <= 0 && (y.push(g), S++), g > 0 && (j.push(g), _++);
    }
    const k = y.reduce((b, g) => b + g, 0) / S, v = { max: j.reduce((b, g) => b + g, 0) / _, min: k };
    v.max > i && (i = v.max), Math.abs(v.min) > i && (i = Math.abs(v.min)), p.push(v);
  }
  if (c * 0.8 > i * c) {
    const a = c * 0.8 / i;
    p = p.map((y) => ({
      max: y.max * a,
      min: y.min * a
    }));
  }
  return p;
}, ie = (f, d, C, R, h, E, w, s = 0, c = 1) => {
  const p = d.height / 2, i = d.getContext("2d");
  if (!i)
    return;
  i.clearRect(0, 0, d.width, d.height), h !== "transparent" && (i.fillStyle = h, i.fillRect(0, 0, d.width, d.height));
  const a = (s || 0) / c;
  f.forEach((y, S) => {
    const j = S / f.length, _ = a > j;
    i.fillStyle = _ && w ? w : E;
    const k = S * (C + R), O = p + y.min, v = C, b = p + y.max - O;
    i.beginPath(), i.roundRect ? (i.roundRect(k, O, v, b, 50), i.fill()) : i.fillRect(k, O, v, b);
  });
}, Rr = dr(
  ({
    blob: f,
    width: d,
    height: C,
    barWidth: R = 2,
    gap: h = 1,
    currentTime: E,
    style: w,
    backgroundColor: s = "transparent",
    barColor: c = "rgb(184, 184, 184)",
    barPlayedColor: p = "rgb(160, 198, 255)"
  }, i) => {
    const a = Fe(null), [y, S] = U([]), [j, _] = U(0);
    return vr(
      i,
      () => a.current,
      []
    ), z(() => {
      (async () => {
        if (!a.current)
          return;
        if (!f) {
          const b = Array.from({ length: 100 }, () => ({
            max: 0,
            min: 0
          }));
          ie(
            b,
            a.current,
            R,
            h,
            s,
            c,
            p
          );
          return;
        }
        const O = await f.arrayBuffer();
        await new AudioContext().decodeAudioData(O, (b) => {
          if (!a.current)
            return;
          _(b.duration);
          const g = yr(
            b,
            C,
            d,
            R,
            h
          );
          S(g), ie(
            g,
            a.current,
            R,
            h,
            s,
            c,
            p
          );
        });
      })();
    }, [f, a.current]), z(() => {
      a.current && ie(
        y,
        a.current,
        R,
        h,
        s,
        c,
        p,
        E,
        j
      );
    }, [E, j]), /* @__PURE__ */ Ie.jsx(
      "canvas",
      {
        ref: a,
        width: d,
        height: C,
        style: {
          ...w
        }
      }
    );
  }
);
Rr.displayName = "AudioVisualizer";
export {
  Rr as AudioVisualizer,
  _r as LiveAudioVisualizer
};
